/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-cycle */
import React from 'react';
import { Box } from '@mui/material';
import { Grid } from '@mui/system';
import { HeroShimmer, SectionShimmer, BaseShimmer } from '../index';
import '../shimmer.scss';

function HomeShimmer() {
  return (
    <Box className="home-shimmer-wrap">
      {/* Hero Section Shimmer */}
      <HeroShimmer
        showButtons
        showSubtitle
        style={{ minHeight: '500px' }}
      />

      {/* Key Benefits Section Shimmer */}
      <Box sx={{ padding: { xs: '40px 20px', md: '60px 100px' } }}>
        <SectionShimmer
          title
          subtitle
          cards={0}
          style={{ padding: 0 }}
        />

        {/* Tab-like structure for key benefits */}
        <Box sx={{ marginTop: '40px' }}>
          <Box sx={{
            display: 'flex',
            gap: '20px',
            marginBottom: '30px',
            flexDirection: { xs: 'column', sm: 'row' },
            overflowX: { xs: 'auto', sm: 'visible' },
          }}>
            {Array.from({ length: 4 }).map((_, index) => (
              <BaseShimmer
                key={index}
                height="120px"
                width={{ xs: '100%', sm: '200px' }}
                borderRadius="12px"
                style={{ flex: 1, minWidth: { xs: 'auto', sm: '150px' } }}
              />
            ))}
          </Box>

          {/* Active tab content */}
          <Box sx={{
            display: 'flex',
            gap: '40px',
            alignItems: 'center',
            flexDirection: { xs: 'column', md: 'row' },
          }}>
            <Box sx={{ flex: 1, width: '100%' }}>
              <BaseShimmer height="300px" borderRadius="12px" />
            </Box>
            <Box sx={{ flex: 1, width: '100%' }}>
              <BaseShimmer height="32px" width="80%" style={{ marginBottom: '16px' }} />
              <BaseShimmer height="18px" width="100%" style={{ marginBottom: '8px' }} />
              <BaseShimmer height="18px" width="90%" style={{ marginBottom: '8px' }} />
              <BaseShimmer height="18px" width="75%" style={{ marginBottom: '20px' }} />
              <BaseShimmer height="42px" width="140px" borderRadius="6px" />
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Mobile Application Section Shimmer */}
      <Box sx={{ padding: { xs: '40px 20px', md: '60px 100px' }, backgroundColor: '#f8f9fa' }}>
        <Grid container spacing={4} alignItems="center">
          <Grid size={{ xs: 12, md: 6 }}>
            <BaseShimmer height="36px" width="70%" style={{ marginBottom: '20px' }} />
            <BaseShimmer height="18px" width="100%" style={{ marginBottom: '8px' }} />
            <BaseShimmer height="18px" width="95%" style={{ marginBottom: '8px' }} />
            <BaseShimmer height="18px" width="80%" style={{ marginBottom: '30px' }} />

            {/* Download buttons */}
            <Box sx={{
              display: 'flex',
              gap: '16px',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: { xs: 'center', sm: 'flex-start' },
            }}>
              <BaseShimmer height="50px" width="150px" borderRadius="8px" />
              <BaseShimmer height="50px" width="150px" borderRadius="8px" />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <BaseShimmer height={{ xs: '250px', md: '400px' }} borderRadius="12px" />
          </Grid>
        </Grid>
      </Box>

      {/* Farms & Vet Section Shimmer */}
      <Box sx={{ padding: { xs: '40px 20px', md: '60px 100px' } }}>
        <SectionShimmer
          title
          subtitle
          cards={4}
          gridColumns={4}
          showCardImages
          showCardButtons={false}
        />
      </Box>

      {/* Growth Section Shimmer */}
      <Box sx={{ padding: { xs: '40px 20px', md: '60px 100px' }, backgroundColor: '#f8f9fa' }}>
        <Grid container spacing={4} alignItems="center">
          <Grid size={{ xs: 12, md: 6 }}>
            <BaseShimmer height={{ xs: '250px', md: '400px' }} borderRadius="12px" />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <BaseShimmer height="36px" width="80%" style={{ marginBottom: '20px' }} />
            <BaseShimmer height="18px" width="100%" style={{ marginBottom: '8px' }} />
            <BaseShimmer height="18px" width="90%" style={{ marginBottom: '8px' }} />
            <BaseShimmer height="18px" width="85%" style={{ marginBottom: '30px' }} />
            <BaseShimmer height="42px" width="140px" borderRadius="6px" />
          </Grid>
        </Grid>
      </Box>

      {/* Success Stories Section Shimmer */}
      <Box sx={{ padding: { xs: '40px 20px', md: '60px 100px' } }}>
        <SectionShimmer
          title
          subtitle
          cards={3}
          gridColumns={3}
          showCardImages
          showCardButtons={false}
        />
      </Box>

      {/* Schedule Appointment Section Shimmer */}
      <Box sx={{ padding: { xs: '40px 20px', md: '60px 100px' }, backgroundColor: '#114559' }}>
        <Box sx={{ textAlign: 'center' }}>
          <BaseShimmer
            height="36px"
            width={{ xs: '80%', md: '50%' }}
            style={{
              margin: '0 auto 20px',
              background: 'linear-gradient(90deg, #2a3a4a 25%, #3a4a5a 50%, #2a3a4a 75%)',
              backgroundSize: '200px 100%',
            }}
          />
          <BaseShimmer
            height="18px"
            width={{ xs: '90%', md: '70%' }}
            style={{
              margin: '0 auto 30px',
              background: 'linear-gradient(90deg, #2a3a4a 25%, #3a4a5a 50%, #2a3a4a 75%)',
              backgroundSize: '200px 100%',
            }}
          />
          <BaseShimmer
            height="42px"
            width="160px"
            borderRadius="6px"
            style={{
              margin: '0 auto',
              background: 'linear-gradient(90deg, #2a3a4a 25%, #3a4a5a 50%, #2a3a4a 75%)',
              backgroundSize: '200px 100%',
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default HomeShimmer;
